/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProspectContext } from "../context/prospectContext";
import { prospectNotification } from "../utils/alerts";
import useUser from "./useUser";

const useProspect = (t) => {
  const ibo = JSON.parse(localStorage.getItem("iboInfo"));
  const contact = JSON.parse(localStorage.getItem("contact"));
  /* Sesión real del IBO — si existe, nunca disparamos el gate del
     prospecto porque el usuario YA está autenticado. Antes el gate
     solo miraba `ibo && !contact` y abría el modal de datos para IBOs
     logueados que tenían iboInfo residual en localStorage de una
     visita previa, impidiendo navegar a cualquier curso (incluso
     "Repasar" en los Completados). */
  const userInfoQursiva = JSON.parse(
    localStorage.getItem("userInfoQursiva")
  );
  const emailRegex =
    /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

  const { getUserByEmail, create } = useUser();

  const navigate = useNavigate();
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mainUserId: ibo?.userId,
    userTypeId: 9,
    createdBy: ""
  };

  const [formModal, setFormModal] = useState(initialValues);
  const [customerInfo, setCustomerInfo] = useState({});
  const [enableButton, setEnableButton] = useState(true);
  const [isVisibleProspect, setIsVisibleProspect] = useState(false);
  const [codeCourse, setCodeCourse] = useState("");
  const { setProspectInfoLocal } = useContext(ProspectContext);

  const toggleModalProspect = () => setIsVisibleProspect(!isVisibleProspect);

  useEffect(() => {
    async function getInfo() {
      if (emailRegex.test(formModal.email)) {
        const response = await getUserByEmail(formModal.email);
        if (response.status === 200) {
          setCustomerInfo(response.data.data);
          setEnableButton(false);
        } else {
          setCustomerInfo({});
        }
      } else {
        setCustomerInfo({});
      }
    }
    getInfo();
  }, [formModal.email]);

  useEffect(() => {
    const enable = enableConfirm();
    setEnableButton(enable);
  }, [formModal, customerInfo]);

  const itsProspect = ({ code, uri }) => {
    /* El gate solo aplica a visitantes INVITADOS (iboInfo + sin contact
       + SIN sesión real). Con `userInfoQursiva` presente el usuario ya
       está autenticado como IBO y no debería ver el modal de prospecto. */
    if (ibo && !contact && !userInfoQursiva) {
      toggleModalProspect();
    } else if (code) {
      navigate(`/courses-details/${code}`);
    } else {
      navigate(uri);
    }
  };

  const enableConfirm = () => {
    if (
      (formModal?.email &&
        formModal?.name &&
        formModal?.lastName) ||
      (customerInfo?.email &&
        customerInfo?.name &&
        customerInfo?.lastName)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleChangeEmail = (e) => {
    const { name, value } = e.target;
    setFormModal({
      ...formModal,
      [name]: value,
    });
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormModal({
      ...formModal,
      [name]: value,
    });
  };

  const handleChangeSelect = ({ name, value }) => {
    setFormModal({
      ...formModal,
      [name]: value,
    });
  };

  const handleChangeBirthday = (value, dateString) => {
    setFormModal({
      ...formModal,
      BirthDate: dateString,
    });
  };

  /* Extractor de userRelationId — el shape del backend varía entre
     entornos, se toleran tres nombres y dos tipos de relación válida
     (9 prospecto, 3 contacto). Fallback al primero de la lista si
     no hay filtro que matchee. */
  const pickUserRelationId = (source) => {
    const list =
      source?.userRelation ??
      source?.userRelations ??
      source?.UserRelation ??
      [];
    const filtered = Array.isArray(list)
      ? list.find(
          (item) => item.userTypeId === 9 || item.userTypeId === 3
        )
      : null;
    return filtered?.id ?? (Array.isArray(list) ? list[0]?.id : undefined);
  };

  /** El modal llama esto al perder foco del email — no en tiempo real
   *  por cada tecla, así evitamos N peticiones mientras el usuario
   *  tipea. Devuelve el objeto customer si el email existe en BD, o
   *  `null` si no. El modal usa el resultado para decidir la rama de
   *  `handleSubmit`. */
  const checkEmailInBD = async (email) => {
    if (!email || !emailRegex.test(email)) return null;
    try {
      const response = await getUserByEmail(email);
      console.log("[useProspect] getUserByEmail →", response);
      if (response?.status === 200) {
        return response.data?.data ?? response.data ?? null;
      }
    } catch (err) {
      console.error("[useProspect] getUserByEmail fallo:", err);
    }
    return null;
  };

  /** Persiste el prospecto y navega al destino. Rama única —
   *  `customer` es la respuesta previa de `checkEmailInBD` o `null`
   *  si no había email en BD. */
  const handleSubmit = async (uri, formData) => {
    const src = formData ?? formModal;
    const email = (src.email || "").trim();
    const name = (src.name || src.firstName || "").trim();
    const lastName = (src.lastName || "").trim();
    const customer = src.customer ?? null;

    console.log("[useProspect] handleSubmit", { email, name, lastName, customer });

    if (!email || !name || !lastName) {
      console.warn("[useProspect] datos incompletos", src);
      return;
    }

    const target =
      uri || (codeCourse ? `/courses-details/${codeCourse}` : null);

    const finalize = () => {
      toggleModalProspect();
      setCustomerInfo({});
      setFormModal(initialValues);
      prospectNotification(t("prospect.validate"), "info");
      if (target) navigate(target);
    };

    /* Email YA existía en BD → enlazamos sin crear. */
    if (customer && Object.keys(customer).length > 0) {
      const prospectInfo = {
        userId: customer.userId ?? customer.id,
        id: customer.userId ?? customer.id,
        firstName: name || customer.name || customer.firstName,
        lastName: lastName || customer.lastName || customer.LastName,
        email,
        userRelationId: pickUserRelationId(customer),
      };
      console.log("[useProspect] enlazando existente", prospectInfo);
      setProspectInfoLocal(prospectInfo);
      finalize();
      return;
    }

    /* Email nuevo — creamos prospecto. */
    const request = {
      firstName: name,
      lastName,
      email,
      password: "",
      mainUserId: ibo?.userId ?? ibo?.id,
      userTypeId: 9,
      createdBy: email,
    };
    console.log("[useProspect] create request", request);
    let response;
    try {
      response = await create(request);
    } catch (err) {
      console.error("[useProspect] create fallo:", err);
      response = null;
    }
    console.log("[useProspect] create response", response);

    if (response?.status === 201 || response?.status === 200) {
      const created = response.data?.data ?? response.data ?? {};
      const prospectInfo = {
        userId: created.userId ?? created.id,
        id: created.userId ?? created.id,
        firstName: name,
        lastName,
        email,
        userRelationId: pickUserRelationId(created),
      };
      console.log("[useProspect] guardado nuevo", prospectInfo);
      setProspectInfoLocal(prospectInfo);
      finalize();
      return;
    }

    prospectNotification(
      t("prospect.error", "No pudimos guardar tus datos. Inténtalo de nuevo."),
      "danger"
    );
  };

  return {
    handleChangeEmail,
    customerInfo,
    handleSubmit,
    handleChangeInput,
    handleChangeSelect,
    handleChangeBirthday,
    enableButton,
    ibo,
    itsProspect,
    isVisibleProspect,
    toggleModalProspect,
    setCodeCourse,
    /* Nuevas — expuestas para el modal autocontenido. */
    checkEmailInBD,
  };
};

export default useProspect;
